import { ImpostoRecuperavelEnum } from '@shared/enums/suprimentos/imposto-recuperavel.enum';
import { TipoBasePrecoVendaEnum } from '@shared/enums/suprimentos/tipo-base-preco-venda.enum';
import { NFeEntradaFormacaoPrecosItemPreviaRequest } from './nfe-entrada-formacao-precos-item-previa.request';

/** Escolhas da tela de formação de preços; os valores fiscais são sempre relidos da nota pelo servidor. */
export class NFeEntradaFormacaoPrecosPreviaRequest {
  public idNFeEntrada = 0;
  /** Nulo usa o frete da nota. */
  public valorFrete: number | null = null;
  /** Impostos abatidos do custo; os ausentes deixam de ser recuperados. */
  public idsImpostoRecuperavel: ImpostoRecuperavelEnum[] = [];
  public idTipoBasePrecoVenda = TipoBasePrecoVendaEnum.PrecoCustoCompra;
  public itens: NFeEntradaFormacaoPrecosItemPreviaRequest[] = [];
}
